<template>
  <div class="flex flex-col justify-center items-center w-full px-22 gap-4">
    <PasswordInput v-model="currentPasssword" placeholder="رمزعبور فعلی" />
    <PasswordInput v-model="newPassword" placeholder="رمزعبور جدید" />
    <PasswordInput
      v-model="newPasswordRepeat"
      placeholder="تکرار رمزعبور جدید"
    />
  </div>
  <div class="w-full flex justify-end px-22 mt-5 mobile:mb-2">
    <button
      class="bg-blue-primary transition-colors hover:bg-blue-primary-darker text-white rounded-lg py-2 px-4"
      @click="handleChangePassword"
    >
      ذخیره
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PasswordInput from "../PasswordInput.vue";

const currentPasssword = ref("");
const newPassword = ref("");
const newPasswordRepeat = ref("");

const handleChangePassword = () => {
  console.log("change");
};
</script>
